import {Observable, Subscription} from 'rxjs';

import ILocalStorageStore from '../Interfaces/ILocalStorageStore';

const subscribeToVolumeWrite = (
    volumeLevelWriteStream$: Observable<number>,
    localStorageStore: ILocalStorageStore
): Subscription =>
    volumeLevelWriteStream$
        .subscribe(level => {
            if (level > 0) {
                localStorageStore.actions.write({volumeLevel: level});
            }
        });

export default subscribeToVolumeWrite;